enum LocationTypeEnum {
  Urban = 'Urban',
  Suburban = 'Suburban',
  Rural = 'Rural',
}

export default LocationTypeEnum;
